import { Button } from "@/components";
import { PrismicRichText } from "@prismicio/react";
import { useRef } from "react";
import Styles from "./LeadMagnet.module.css";
import Select from "@/components/ContactForm/Select/Select";

const LeadMagnet = ({ primary }) => {
  const formRef = useRef(null);

  const handleSubmit = (event) => {
    event.preventDefault();

    // Download the file
    if (primary?.media_link) {
      const link = document.createElement("a");
      link.href = primary?.media_link?.url;
      link.download = primary?.media_link?.name;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    formRef.current && formRef.current.submit();

    // Fire GTM event
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "lead_magnet_form_submit",
      pageTitle: document.title,
      pageUrl: window.location.href,
    });
  };

  return (
    <section
      className={Styles.wrapper}
      style={{
        backgroundImage: primary?.background_image?.url
          ? `url(${primary.background_image.url})`
          : undefined,
      }}
    >
      <div className={Styles.container} data-contain="true">
        <div className={Styles.col}>
          <span className={Styles.heading}>
            <PrismicRichText field={primary?.heading} />
          </span>
          <span className={Styles.description}>
            <PrismicRichText field={primary?.description} />
          </span>
        </div>
        <div className={Styles.col}>
          <div className={Styles.box}>
            <span className={Styles.formHeading}>
              <h4>{primary?.form_heading}</h4>
            </span>
            <span className={Styles.formDescription}>
              <PrismicRichText field={primary?.form_description} />
            </span>
            <form
              className={Styles.form}
              ref={formRef}
              onSubmit={handleSubmit}
              data-form="true"
              name="lead-magnet-form-cmp"
              id="lead-magnet-form"
            >
              <div className="formRow">
                <div className="formGroup">
                  <label htmlFor="first-name">First Name</label>
                  <input
                    id="first-name"
                    type="text"
                    placeholder="Enter your first name"
                    required
                  />
                </div>

                <div className="formGroup">
                  <label htmlFor="last-name">Last Name</label>
                  <input
                    id="last-name"
                    type="text"
                    placeholder="Enter your last name"
                    required
                  />
                </div>
              </div>
              <div className="formRow">
                <div className="formGroup">
                  <label htmlFor="email">Email</label>
                  <input
                    id="email"
                    type="email"
                    placeholder="Enter your email"
                    required
                  />
                </div>
                <Select
                  label="Industry"
                  name="primary_industry"
                  options={[
                    {
                      label: "Wind Energy",
                      value: "Wind Energy",
                    },
                    {
                      label: "Utility",
                      value: "Utility",
                    },
                    {
                      label: "Telecommunications",
                      value: "Telecommunications",
                    },
                    {
                      label: "Construction",
                      value: "Construction",
                    },
                    {
                      label: "Oil & Gas",
                      value: "Oil & Gas",
                    },
                    {
                      label: "Other",
                      value: "Other",
                    },
                  ]}
                />
              </div>
              <Button
                type="submit"
                submit={true}
                label={primary?.submit_label || "Submit"}
                variant="primary"
              />
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadMagnet;
